import { HttpParams } from '@angular/common/http'
import { ChangeDetectorRef, Component, effect, inject, input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, Grid, ListItem } from '../../../shared'
import { GridColumnGroupComponent } from '../../../shared/reusable-components/grid-column-group/grid-column-group.component'
import { GridSelectionCalculationComponent } from '../../../shared/reusable-components/grid-selection-calculation/grid-selection-calculation.component'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-lifetime-meter',
    templateUrl: './lifetime-meter.component.html',
    standalone: true,
    imports: [
        FormsModule,
        WjInputModule,
        GridColumnGroupComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        GridSelectionCalculationComponent,
    ],
})
export class LifetimeMeterComponent extends BaseComponent {
    active = input.required<number>()
    cdr = inject(ChangeDetectorRef)

    optionsFetched = false
    sourcesList: ListItem<string>[] = []
    selectedSource!: string

    reconGrid: Grid<any>

    constructor() {
        super()

        this.reconGrid = new Grid<any>(this.services)

        effect(() => {
            if (this.active() === 10) {
                this.refreshOptions()
            }
        })
    }

    refreshOptions() {
        this.cancelableRequest(
            'GetLifetimeMeterOptions',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/FuelAnalytics/GetLifetimeMeterOptions')).subscribe({
                next: result => {
                    this.optionsFetched = true
                    this.sourcesList = result[0].map(x => new ListItem(x, x))
                    console.log('sourcesList', this.sourcesList)
                    this.cdr.detectChanges()
                },
            }),
        )
    }

    refresh() {
        this.cancelableRequest(
            'GetLifetimeMeterAnalytics',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.get(
                        '/api/FuelAnalytics/GetLifetimeMeterAnalytics',
                        new HttpParams().set('source', this.selectedSource),
                    ),
                )
                .subscribe({
                    next: result => {
                        this.reconGrid.items = result[0]
                        console.log('GetLifetimeMeterAnalytics', result[0])
                    },
                }),
        )
    }
}
